import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { TrustBar } from "./components/TrustBar";
import { ProductShowcase } from "./components/ProductShowcase";
import { About } from "./components/about";
import { TechAdvantage } from "./components/TechAdvantage";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { CtaSection } from "./components/CtaSection";
import { Footer } from "./components/Footer";
import BioBackground from "./components/BioBackground";
import ProductPage from "./components/ProductPage";
import PrivacyPolicy from "./components/PrivacyPolicy";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <BioBackground />
        <div style={{ position: 'relative', zIndex: 1 }}>
      <Navigation data={landingPageData.Navigation} />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header data={landingPageData.Hero} />
              <TrustBar />
              <ProductShowcase data={landingPageData.Products} />
              <About data={landingPageData.UseCases} />
              <TechAdvantage data={landingPageData.Technology} />
              <Testimonials data={landingPageData.Value} />
              <Team data={landingPageData.Team} />
              <CtaSection data={landingPageData.Cta} />
              <Footer data={landingPageData.Footer} />
            </>
          }
        />
        <Route path="/products/:slug" element={<ProductPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
